import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@material-ui/core';

interface PolicyPopupProps {
  open: boolean;
  title: string;
  htmlDescription: string; // HTML string
  onClose: () => void;
}

const PolicyPopup: React.FC<PolicyPopupProps> = ({ open, title, htmlDescription, onClose }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>
        {/* Render HTML safely */}
        <Typography component="div" dangerouslySetInnerHTML={{ __html: htmlDescription }} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PolicyPopup;
